/**
 * Premium Footer — mobile accordion behavior.
 *
 * Desktop/tablet: columns are always expanded (handled purely in CSS via
 * the `@media (min-width: 750px)` override), so this script has nothing
 * to do above 749px.
 *
 * Mobile (<=749px): each `[data-pf-col]` becomes a collapsible accordion.
 * Clicking its `[data-pf-col-toggle]` button flips `data-pf-open` and the
 * CSS grid-rows transition in premium-footer.css handles the animation.
 * Product/Company/Support links inside stay fully clickable either way —
 * this script never calls preventDefault on anything but the toggle
 * buttons themselves.
 */
(function () {
  'use strict';

  function initAccordion(root) {
    var columns = root.querySelectorAll('[data-pf-col]');

    columns.forEach(function (col) {
      var toggle = col.querySelector('[data-pf-col-toggle]');
      if (!toggle || toggle.dataset.pfBound) return;
      toggle.dataset.pfBound = 'true';

      toggle.addEventListener('click', function () {
        if (window.innerWidth > 749) return; // desktop/tablet: always open, ignore clicks

        var isOpen = col.getAttribute('data-pf-open') === 'true';
        col.setAttribute('data-pf-open', String(!isOpen));
        toggle.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  function initNewsletterMessage(root) {
    var message = root.querySelector('[data-pf-newsletter-message]');
    if (!message) return;

    window.setTimeout(function () {
      message.style.transition = 'opacity 0.4s ease';
      message.style.opacity = '0';
    }, 6000);
  }

  function initRevealAnimation(root) {
    var items = root.querySelectorAll('[data-pf-reveal]');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    items.forEach(function (el) { observer.observe(el); });
  }

  function init() {
    var footer = document.querySelector('.pf');
    if (!footer) return;
    initAccordion(footer);
    initNewsletterMessage(footer);
    initRevealAnimation(footer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector && event.target.querySelector('.pf')) {
      init();
    }
  });
})();
